import { createContext, Dispatch, SetStateAction } from "react";
import { RefetchCompetencyMapGenQuestionsLog } from "./components/types";

export interface ConstructorTabContextValue {
  skillsIdsToDelete: string[];
  setSkillsIdsToDelete: Dispatch<SetStateAction<string[]>>;
  refetchCompetencyMapGenQuestionsLog: RefetchCompetencyMapGenQuestionsLog | (() => void);
}

export const ConstructorTabContext = createContext<ConstructorTabContextValue>({
  skillsIdsToDelete: [],
  setSkillsIdsToDelete: () => {},
  refetchCompetencyMapGenQuestionsLog: () => {},
});
